<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-xl">
          <section class="section-hotels-edit-rooms">
            <div class="hotels-wrap">
              <HotelsSideMenu />
              <div class="hotels-content">
                <div class="hotel-inner-prices">
                  <h1 class="hotel-inner__title">{{ hotelName }}</h1>
                  <form>
                    <div class="page-title-2">
                      <h2>Prices</h2>
                    </div>
                    <div class="prices-top">
                      <div class="line-cols">
                        <div class="form-control-group">
                          <span class="form-control-label">Year</span>
                          <div class="form-control-wrap">
                            <div
                              :class="[
                                'select-wrapper',
                                {'is-active': selects.year},
                              ]"
                              @click="onCheckIsEdit('year')">
                              <div class="select-trigger">
                                <span class="select-trigger__name">{{
                                  year || ''
                                }}</span>
                                <span class="select-trigger__icon">
                                  <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-chevron">
                                    <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                  </svg>
                                </span>
                              </div>
                              <div class="select-body">
                                <div class="select-inner js-scrollbar">
                                  <div
                                    v-for="(item, index) in data.years"
                                    :key="index"
                                    :class="[
                                      'select-option',
                                      {'is-selected': item === year},
                                    ]"
                                    @click="year = item">
                                    <span class="select-option__name">{{
                                      item
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="btn_copy-price">
                          <button
                            type="button"
                            data-popover="Copy rates from the previous year"
                            class="btn btn--green btn--sm-squared btn--popover"
                            @click="copyPopup = true">
                            <svg
                              width="1em"
                              height="1em"
                              class="icon icon-copy">
                              <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="resultType"
                      class="hotel-subtitle hotel-subtitle_based"
                      :style="{marginBottom: '0px'}">
                      Based on: <span>{{ resultType }}</span>
                    </div>
                    <div
                      v-for="(item, index) in prices"
                      :key="index"
                      :class="[
                        'hotels-item hotels-item_prices bl-sm hotels-item_prices-mod js-collapse',
                        {'is-collapsed': item.collapse},
                      ]"
                      :style="{paddingTop: index === 0 ? '30px' : '0px'}">
                      <div class="hotels-title">
                        <div class="inline-flex-center">
                          <span class="form-control-label">{{
                            item.roomName
                          }}</span>
                          <button
                            data-popover="Copy prices to chosen rooms"
                            :style="{minWidth: '34px'}"
                            type="button"
                            class="btn btn--green btn--sm-squared btn--popover btn--popover--left non-after"
                            @click="onShowCopyPricesPopup(index)">
                            <svg
                              width="13"
                              height="13"
                              viewBox="0 0 13 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M8.8535 3.25174V0H4.30176V9.10001H12.1018V3.25174H8.8535Z"
                                fill="white" />
                              <path
                                d="M10.1533 0V1.95174H12.1051L10.1533 0Z"
                                fill="white" />
                              <path
                                d="M3.00137 10.3996V2.59961H0.401367V12.9996H9.50138V10.3996H3.00137Z"
                                fill="white" />
                            </svg>
                          </button>
                          <button
                            type="button"
                            data-opened="Hide"
                            data-closed="Show"
                            :class="[
                              'btn btn--collapse js-collapse-trigger',
                              {'is-active': item.collapse},
                            ]"
                            @click="item.collapse = !item.collapse">
                            <span class="btn--collapse__icon">
                              <svg
                                width="1em"
                                height="1em"
                                class="icon icon-collapse">
                                <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                              </svg>
                            </span>
                          </button>
                        </div>
                      </div>
                      <div class="hotels-body js-collapse-inner">
                        <div class="section-table-wrap prices-tables-wrap">
                          <div class="prices-tables">
                            <div class="accommodation-table">
                              <div
                                class="accommodation-table__item accommodation-table__item--head">
                                <div :class="['accommodation-table__tr']">
                                  <div
                                    class="accommodation-table__td accommodation-table__td--1"></div>
                                  <div
                                    class="accommodation-table__td accommodation-table__td--2"></div>
                                  <div
                                    v-for="(season, idx) in item.seasons"
                                    :key="idx"
                                    :class="
                                      'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data'
                                    ">
                                    <span>{{ season.seasonName }}</span>
                                  </div>
                                </div>
                              </div>
                              <div :class="['accommodation-table__tr']">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-adult">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >Per Person Rate</span
                                    >
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input
                                      type="radio"
                                      v-model="item.types.perPersonRate.type"
                                      @change="isEdit = true"
                                      value="STATIC" />
                                    <span class="ic-info__label">$</span></label
                                  >
                                  <!-- <label class="ic-info ic-action" > <input type="radio" v-model="item.types.perPersonRate.type" value="PERCENT"><span class="ic-info__label">%</span></label> -->
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <!--                                                                    <input type="number" v-model="season.prices.perPersonRate.price" @change="isEdit = true">-->
                                  <input
                                    type="number"
                                    v-model="
                                      season.prices.perPersonRate.price
                                    " />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Базовая стоимость за участника при
                                      проживании, при расчете цены Single номера
                                      комбинируется с <b>Single Supplement</b>,
                                      при расчете цены Double номера умножается
                                      <b>х2</b></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                              <div
                                :class="[
                                  'accommodation-table__tr',
                                  {
                                    'disabled-item':
                                      !item.types.singleSupplement.enabled,
                                  },
                                ]">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-adult">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >Single Supplement</span
                                    >
                                  </div>
                                  <div class="switch">
                                    <label class="switch-label"
                                      ><input
                                        type="checkbox"
                                        v-model="
                                          item.types.singleSupplement.enabled
                                        "
                                        @change="isEdit = true" />
                                      <span class="switch-inp"></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input
                                      type="radio"
                                      v-model="item.types.singleSupplement.type"
                                      @change="isEdit = true"
                                      value="STATIC" /><span
                                      class="ic-info__label"
                                      >$</span
                                    ></label
                                  >
                                  <label class="ic-info ic-action">
                                    <input
                                      type="radio"
                                      v-model="item.types.singleSupplement.type"
                                      @change="isEdit = true"
                                      value="PERCENT" /><span
                                      class="ic-info__label"
                                      >%</span
                                    ></label
                                  >
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <input
                                    type="number"
                                    v-model="
                                      season.prices.singleSupplement.price
                                    "
                                    @change="isEdit = true" />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Участвует для расчета стоимости
                                      одноместного номера. Формула
                                      <b
                                        >Single = Per Person Rate + Single
                                        Supplement</b
                                      ></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                              <div
                                :class="[
                                  'accommodation-table__tr',
                                  {
                                    'disabled-item':
                                      !item.types.thirdAdult.enabled,
                                  },
                                ]">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-adult">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >3rd Adult</span
                                    >
                                  </div>
                                  <div class="switch">
                                    <label class="switch-label"
                                      ><input
                                        type="checkbox"
                                        v-model="item.types.thirdAdult.enabled"
                                        @change="isEdit = true" />
                                      <span class="switch-inp"></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input
                                      type="radio"
                                      v-model="item.types.thirdAdult.type"
                                      value="STATIC"
                                      @change="isEdit = true" /><span
                                      class="ic-info__label"
                                      >$</span
                                    ></label
                                  >
                                  <label class="ic-info ic-action">
                                    <input
                                      type="radio"
                                      v-model="item.types.thirdAdult.type"
                                      value="PERCENT"
                                      @change="isEdit = true" /><span
                                      class="ic-info__label"
                                      >%</span
                                    ></label
                                  >
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <input
                                    type="number"
                                    v-model="season.prices.thirdAdult.price"
                                    @change="isEdit = true" />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Используется для расчета стоимости
                                      трёхместного номера. Формула
                                      <b
                                        >Triple = Per Person Rate x2 + 3rd
                                        Adult</b
                                      ></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                              <div
                                :class="[
                                  'accommodation-table__tr',
                                  {
                                    'disabled-item':
                                      !item.types.teenagerAlone.enabled,
                                  },
                                ]">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-teenager">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >Teenager
                                      <span>(Alone in Single)</span></span
                                    >
                                  </div>
                                  <div class="switch">
                                    <label class="switch-label"
                                      ><input
                                        type="checkbox"
                                        v-model="
                                          item.types.teenagerAlone.enabled
                                        "
                                        @change="isEdit = true" />
                                      <span class="switch-inp"></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input type="checkbox" checked /><span
                                      class="ic-info__label"
                                      >$</span
                                    ></label
                                  >
                                  <!-- <label class="ic-info ic-action"> <input type="checkbox"><span class="ic-info__label">%</span></label> -->
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <input
                                    type="number"
                                    v-model="season.prices.teenagerAlone.price"
                                    @change="isEdit = true" />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Используется для расчета стоимость
                                      одноместного номера, в котором живет один
                                      подросток. Формула
                                      <b
                                        >Single (for Teenager) = Teenager</b
                                      ></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                              <div
                                :class="[
                                  'accommodation-table__tr',
                                  {
                                    'disabled-item':
                                      !item.types.firstTeenager1Adult.enabled,
                                  },
                                ]">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-teenager">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >1st Teenager
                                      <span>(sharing with 1 Adult)</span></span
                                    >
                                  </div>
                                  <div class="switch">
                                    <label class="switch-label"
                                      ><input
                                        type="checkbox"
                                        v-model="
                                          item.types.firstTeenager1Adult.enabled
                                        "
                                        @change="isEdit = true" />
                                      <span class="switch-inp"></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.firstTeenager1Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="STATIC" /><span
                                      class="ic-info__label"
                                      >$</span
                                    ></label
                                  >
                                  <label class="ic-info ic-action">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.firstTeenager1Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="PERCENT" /><span
                                      class="ic-info__label"
                                      >%</span
                                    ></label
                                  >
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <input
                                    type="number"
                                    v-model="
                                      season.prices.firstTeenager1Adult.price
                                    "
                                    @change="isEdit = true" />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Используется для расчета стоимости
                                      проживания в номере одного взрослого и
                                      одного подростка. Формула расчета:
                                      <b
                                        >Per Person Rate + 1st Teenager (sharing
                                        with 1 Adult</b
                                      ></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                              <div
                                :class="[
                                  'accommodation-table__tr',
                                  {
                                    'disabled-item':
                                      !item.types.firstTeenager2Adult.enabled,
                                  },
                                ]">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-teenager">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >1st Teenager
                                      <span>(sharing with 2 Adults)</span>
                                    </span>
                                  </div>
                                  <div class="switch">
                                    <label class="switch-label"
                                      ><input
                                        type="checkbox"
                                        v-model="
                                          item.types.firstTeenager2Adult.enabled
                                        "
                                        @change="isEdit = true" />
                                      <span class="switch-inp"></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.firstTeenager2Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="STATIC" /><span
                                      class="ic-info__label"
                                      >$</span
                                    ></label
                                  >
                                  <label class="ic-info ic-action">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.firstTeenager2Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="PERCENT" /><span
                                      class="ic-info__label"
                                      >%</span
                                    ></label
                                  >
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <input
                                    type="number"
                                    v-model="
                                      season.prices.firstTeenager2Adult.price
                                    "
                                    @change="isEdit = true" />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Используется для расчета стоимости
                                      проживания в номере двух взрослых и одного
                                      подростка. Формула расчета:
                                      <b
                                        >Per Person Rate х2 + 1st Teenager
                                        (sharing with 2 Adults)</b
                                      ></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                              <div
                                :class="[
                                  'accommodation-table__tr',
                                  {
                                    'disabled-item':
                                      !item.types.secondTeenager1Adult.enabled,
                                  },
                                ]">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-teenager">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >2nd Teenager
                                      <span>(sharing with 1 Adult)</span>
                                    </span>
                                  </div>
                                  <div class="switch">
                                    <label class="switch-label"
                                      ><input
                                        type="checkbox"
                                        v-model="
                                          item.types.secondTeenager1Adult
                                            .enabled
                                        "
                                        @change="isEdit = true" />
                                      <span class="switch-inp"></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.secondTeenager1Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="STATIC" /><span
                                      class="ic-info__label"
                                      >$</span
                                    ></label
                                  >
                                  <label class="ic-info ic-action">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.secondTeenager1Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="PERCENT" /><span
                                      class="ic-info__label"
                                      >%</span
                                    ></label
                                  >
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <input
                                    type="number"
                                    v-model="
                                      season.prices.secondTeenager1Adult.price
                                    "
                                    @change="isEdit = true" />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Используется для расчета стоимости
                                      проживания в номере одного взрослого и
                                      двух подростков. Формула расчета:
                                      <b
                                        >Per Person Rate + 1st Teenager (sharing
                                        with 1 Adult) + 2nd Teenager (sharing
                                        with 1 Adult)</b
                                      ></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                              <div
                                :class="[
                                  'accommodation-table__tr',
                                  {
                                    'disabled-item':
                                      !item.types.secondTeenager2Adult.enabled,
                                  },
                                ]">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-teenager">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >2nd Teenager
                                      <span>(sharing with 2 Adults)</span></span
                                    >
                                  </div>
                                  <div class="switch">
                                    <label class="switch-label"
                                      ><input
                                        type="checkbox"
                                        v-model="
                                          item.types.secondTeenager2Adult
                                            .enabled
                                        "
                                        @change="isEdit = true" />
                                      <span class="switch-inp"></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.secondTeenager2Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="STATIC" /><span
                                      class="ic-info__label"
                                      >$</span
                                    ></label
                                  >
                                  <label class="ic-info ic-action">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.secondTeenager2Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="PERCENT" /><span
                                      class="ic-info__label"
                                      >%</span
                                    ></label
                                  >
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <input
                                    type="number"
                                    v-model="
                                      season.prices.secondTeenager2Adult.price
                                    "
                                    @change="isEdit = true" />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Используется для расчета стоимости
                                      проживания в номере двух взрослых и двух
                                      подростков. Формула расчета:
                                      <b
                                        >Per Person Rate х2 + 1st Teenager
                                        (sharing with 2 Adults) + 2nd Teenager
                                        (sharing with 2 Adults)</b
                                      ></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                              <div
                                :class="[
                                  'accommodation-table__tr',
                                  {
                                    'disabled-item':
                                      !item.types.firstChild1Adult.enabled,
                                  },
                                ]">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-child">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >1st child
                                      <span>(sharing with 1 Adult)</span></span
                                    >
                                  </div>
                                  <div class="switch">
                                    <label class="switch-label"
                                      ><input
                                        type="checkbox"
                                        v-model="
                                          item.types.firstChild1Adult.enabled
                                        "
                                        @change="isEdit = true" />
                                      <span class="switch-inp"></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input
                                      type="radio"
                                      v-model="item.types.firstChild1Adult.type"
                                      @change="isEdit = true"
                                      value="STATIC" /><span
                                      class="ic-info__label"
                                      >$</span
                                    ></label
                                  >
                                  <label class="ic-info ic-action">
                                    <input
                                      type="radio"
                                      v-model="item.types.firstChild1Adult.type"
                                      @change="isEdit = true"
                                      value="PERCENT" /><span
                                      class="ic-info__label"
                                      >%</span
                                    ></label
                                  >
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <input
                                    type="number"
                                    v-model="
                                      season.prices.firstChild1Adult.price
                                    "
                                    @change="isEdit = true" />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Используется для расчета стоимости
                                      проживания в номере одного взрослого и
                                      одного ребенка. Формула расчета:
                                      <b>Per person rate + 1st child</b></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                              <div
                                :class="[
                                  'accommodation-table__tr',
                                  {
                                    'disabled-item':
                                      !item.types.firstChild2Adult.enabled,
                                  },
                                ]">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-child">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >1st child
                                      <span>(sharing with 2 Adults)</span></span
                                    >
                                  </div>
                                  <div class="switch">
                                    <label class="switch-label"
                                      ><input
                                        type="checkbox"
                                        v-model="
                                          item.types.firstChild2Adult.enabled
                                        "
                                        @change="isEdit = true" />
                                      <span class="switch-inp"></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input
                                      type="radio"
                                      v-model="item.types.firstChild2Adult.type"
                                      @change="isEdit = true"
                                      value="STATIC" /><span
                                      class="ic-info__label"
                                      >$</span
                                    ></label
                                  >
                                  <label class="ic-info ic-action">
                                    <input
                                      type="radio"
                                      v-model="item.types.firstChild2Adult.type"
                                      @change="isEdit = true"
                                      value="PERCENT" /><span
                                      class="ic-info__label"
                                      >%</span
                                    ></label
                                  >
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <input
                                    type="number"
                                    v-model="
                                      season.prices.firstChild2Adult.price
                                    "
                                    @change="isEdit = true" />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Используется для расчета стоимости
                                      проживания в номере двух взрослых и одного
                                      ребенка. Формула расчета:
                                      <b>Per person rate + 1st child</b></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                              <div
                                :class="[
                                  'accommodation-table__tr',
                                  {
                                    'disabled-item':
                                      !item.types.secondChild1Adult.enabled,
                                  },
                                ]">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-child">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >2nd Child
                                      <span>(sharing with 1 Adult)</span></span
                                    >
                                  </div>
                                  <div class="switch">
                                    <label class="switch-label"
                                      ><input
                                        type="checkbox"
                                        v-model="
                                          item.types.secondChild1Adult.enabled
                                        "
                                        @change="isEdit = true" />
                                      <span class="switch-inp"></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.secondChild1Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="STATIC" /><span
                                      class="ic-info__label"
                                      >$</span
                                    ></label
                                  >
                                  <label class="ic-info ic-action">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.secondChild1Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="PERCENT" /><span
                                      class="ic-info__label"
                                      >%</span
                                    ></label
                                  >
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <input
                                    type="number"
                                    v-model="
                                      season.prices.secondChild1Adult.price
                                    "
                                    @change="isEdit = true" />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Используется для расчета стоимости
                                      проживания в номере одного взрослого и
                                      двух детей. Формула расчета:
                                      <b
                                        >Per Person Rate + 1st Child (sharing
                                        with 1 Adult) + 2nd Child (sharing with
                                        1 Adult)</b
                                      ></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                              <div
                                :class="[
                                  'accommodation-table__tr',
                                  {
                                    'disabled-item':
                                      !item.types.secondChild2Adult.enabled,
                                  },
                                ]">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <div class="name-price-it">
                                    <span
                                      class="form-control-group--persons__col">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-child">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                      </svg>
                                    </span>
                                    <span class="accommodation-table__title"
                                      >2nd Child
                                      <span>(sharing with 2 Adults)</span></span
                                    >
                                  </div>
                                  <div class="switch">
                                    <label class="switch-label"
                                      ><input
                                        type="checkbox"
                                        v-model="
                                          item.types.secondChild2Adult.enabled
                                        "
                                        @change="isEdit = true" />
                                      <span class="switch-inp"></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <label class="ic-info ic-price">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.secondChild2Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="STATIC" /><span
                                      class="ic-info__label"
                                      >$</span
                                    ></label
                                  >
                                  <label class="ic-info ic-action">
                                    <input
                                      type="radio"
                                      v-model="
                                        item.types.secondChild2Adult.type
                                      "
                                      @change="isEdit = true"
                                      value="PERCENT" /><span
                                      class="ic-info__label"
                                      >%</span
                                    ></label
                                  >
                                </div>
                                <div
                                  v-for="(season, idx) in item.seasons"
                                  :key="idx"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + index) +
                                      ' accommodation-table__td--item-data',
                                    {
                                      'form-control__help':
                                        idx + 1 === item.seasons.length,
                                    },
                                  ]">
                                  <input
                                    type="number"
                                    v-model="
                                      season.prices.secondChild2Adult.price
                                    "
                                    @change="isEdit = true" />
                                  <span
                                    class="form-control__help-icon"
                                    v-if="idx + 1 === item.seasons.length">
                                    <span class="form-control__help-content"
                                      >Используется для расчета стоимости
                                      проживания в номере двух взрослых и двух
                                      детей. Формула расчета:
                                      <b
                                        >Per Person Rate х2 + 1st Child (sharing
                                        with 2 Adults) + 2nd Child (sharing with
                                        2 Adults)</b
                                      ></span
                                    >
                                    <img
                                      src="/images/useful/svg/help-icon.svg"
                                      alt="" />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="edit-rooms__btn-edit edit-rooms__btn-edit_prices">
                      <button
                        type="button"
                        class="btn btn--green"
                        @click="updatePopup = true">
                        <span>Update</span>
                      </button>
                    </div>

                    <div class="line-prices">
                      <div class="line-prices__group">
                        <div class="hotel-subtitle">Prices</div>
                        <div class="form-control-group">
                          <span class="form-control-label">Filter room</span>
                          <div
                            :class="[
                              'select-wrapper select-wrapper--price-hotel',
                              {'is-active': resultSelect},
                            ]"
                            @click="resultSelect = !resultSelect">
                            <div class="select-trigger">
                              <span class="select-trigger__name">{{
                                filterPrice ? filterPrice.title : ''
                              }}</span>
                              <span class="select-trigger__icon">
                                <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-chevron">
                                  <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg>
                              </span>
                            </div>
                            <div class="select-body">
                              <div class="select-inner js-scrollbar">
                                <div
                                  v-for="(item, index) in data.filter"
                                  :key="index"
                                  :class="[
                                    'select-option',
                                    {'is-active': item === filterPrice},
                                  ]"
                                  @click="filterPrice = item">
                                  <span class="select-option__name">{{
                                    item.title
                                  }}</span>
                                </div>
                                <div
                                  :class="[
                                    'select-option',
                                    {'is-active': filterPrice === 'All'},
                                  ]"
                                  @click="
                                    filterPrice = {title: 'All', type: 'ALL'}
                                  ">
                                  <span class="select-option__name">All</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <label class="form-control-checkbox check-show">
                          <input type="checkbox" v-model="showPrice" /><span
                            class="form-control-checkbox__box">
                            <svg
                              width="1em"
                              height="1em"
                              class="icon icon-check">
                              <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                          ><span class="form-control-checkbox__name">
                            Show price incl all fees</span
                          >
                        </label>
                        <div class="calculation-prices-btn">
                          <button
                            type="button"
                            class="btn btn--green"
                            @click="calcResultsPrices">
                            <span>Calculate prices</span>
                          </button>
                        </div>
                      </div>
                      <div class="line-14">
                        <div class="group-radio-switch" v-if="results.prices">
                          <label class="radio-switch" v-if="results.prices.BB">
                            <input
                              type="radio"
                              v-model="resultType"
                              value="BB"
                              @change="checkedResultType = true" />
                            <span class="radio-switch__label">BB</span>
                          </label>
                          <label class="radio-switch" v-if="results.prices.HB">
                            <input
                              type="radio"
                              v-model="resultType"
                              value="HB"
                              @change="checkedResultType = true" />
                            <span class="radio-switch__label">HB</span>
                          </label>
                          <label class="radio-switch" v-if="results.prices.FB">
                            <input
                              type="radio"
                              v-model="resultType"
                              value="FB"
                              @change="checkedResultType = true" />
                            <span class="radio-switch__label">FB</span>
                          </label>
                          <label class="radio-switch" v-if="results.prices.AI">
                            <input
                              type="radio"
                              v-model="resultType"
                              value="AI"
                              @change="checkedResultType = true" />
                            <span class="radio-switch__label">AI</span>
                          </label>
                          <label class="radio-switch" v-if="results.prices.GP">
                            <input
                              type="radio"
                              v-model="resultType"
                              value="GP"
                              @change="checkedResultType = true" />
                            <span class="radio-switch__label">GP</span>
                          </label>
                        </div>
                      </div>
                      <div class="line-15 section-table-wrap">
                        <div class="accommodation-table prices-finish-tables">
                          <div
                            class="accommodation-table__item accommodation-table__item--head"
                            v-if="filteredResults.length">
                            <div
                              class="accommodation-table__thead"
                              :style="{marginLeft: '14px'}"></div>
                            <div class="accommodation-table__tbody">
                              <div :class="['accommodation-table__tr']">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <span class="accommodation-table__title"
                                    >Accommodation</span
                                  >
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2"></div>
                                <div
                                  v-for="(season, index) in filteredResults[0]
                                    .rooms[0].seasons"
                                  :key="index"
                                  class="accommodation-table__td accommodation-table__td--3">
                                  <span>{{ season.seasonName }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="accommodation-table__item"
                            v-for="(item, index) in filteredResults"
                            :key="index">
                            <div
                              class="accommodation-table__thead"
                              :style="
                                item.type === 'SINGLE'
                                  ? 'background-color: #77B017;'
                                  : item.type === 'DOUBLE'
                                  ? 'background-color: #2493D9;'
                                  : 'background-color: #2e2e2e;'
                              ">
                              <span class="accommodation-table__heading">{{
                                item.type
                              }}</span>
                            </div>
                            <div
                              class="accommodation-table__tbody accommodation-table__tbody--loader"
                              :class="{
                                'accommodation-table__tbody--loading':
                                  pricesUpdating,
                              }">
                              <div
                                class="lds-ring lds-ring--intable"
                                v-if="pricesUpdating">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                              <div
                                v-for="(room, idx) in item.rooms"
                                :key="idx"
                                :class="['accommodation-table__tr']">
                                <div
                                  class="accommodation-table__td accommodation-table__td--1">
                                  <span class="accommodation-table__title">{{
                                    room.roomName
                                  }}</span>
                                </div>
                                <div
                                  class="accommodation-table__td accommodation-table__td--2">
                                  <span
                                    class="form-control-group--persons__col">
                                    <svg
                                      width="1em"
                                      height="1em"
                                      class="icon icon-adult"
                                      v-for="(icon, i) in Array(
                                        room.accommodationData.find(
                                          (d) =>
                                            d.type === 'A' || d.type === 'А'
                                        )
                                          ? room.accommodationData.find(
                                              (d) =>
                                                d.type === 'A' || d.type === 'А'
                                            ).count
                                          : 0
                                      )"
                                      :key="i + 'A'">
                                      <use
                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                    </svg>
                                    <svg
                                      width="1em"
                                      height="1em"
                                      class="icon icon-teenager"
                                      v-for="(icon, i) in Array(
                                        room.accommodationData.find(
                                          (d) => d.type === 'T'
                                        )
                                          ? room.accommodationData.find(
                                              (d) => d.type === 'T'
                                            ).count
                                          : 0
                                      )"
                                      :key="i + 'T'">
                                      <use
                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                    </svg>
                                    <svg
                                      width="1em"
                                      height="1em"
                                      class="icon icon-child"
                                      v-for="(icon, i) in Array(
                                        room.accommodationData.find(
                                          (d) => d.type === 'C'
                                        )
                                          ? room.accommodationData.find(
                                              (d) => d.type === 'C'
                                            ).count
                                          : 0
                                      )"
                                      :key="i + 'C'">
                                      <use
                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                    </svg>
                                  </span>
                                </div>
                                <div
                                  v-for="(price, i) in room.seasons"
                                  :key="i"
                                  :class="[
                                    'accommodation-table__td accommodation-table__td--' +
                                      (3 + i),
                                  ]">
                                  <span v-if="item.type !== 'SPECIFIC'">{{
                                    showPrice
                                      ? price.priceWithFees
                                      : price.price
                                  }}</span>
                                  <input
                                    v-else
                                    type="number"
                                    v-model.number="
                                      showPrice
                                        ? price.priceWithFees
                                        : price.price
                                    "
                                    @change="
                                      updateSpecificHotelPrice(room, price)
                                    " />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="hotel-verify">
                      <div class="hotel-verify__text">
                        <div>Hi {{ user ? user.data.firstName : '' }},</div>
                        <div>Would you like to verify rates?</div>
                        <div class="hotel-verify__date">
                          Today is 15 Apr 2021
                        </div>
                      </div>
                      <div class="hotel-verify__btn">
                        <button
                          type="button"
                          class="btn btn--rounded2 btn--green"
                          @click="verifyPopup = true">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-verify">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-verify"></use>
                          </svg>
                          <span>Verify Rates</span>
                        </button>
                      </div>
                    </div>
                    <div class="hotel-verify-status" v-show="false">
                      Thank you. Rates verified by Alex / 15 Apr 2021
                    </div>
                    <div
                      class="edit-rooms__btn-edit edit-rooms__btn-edit_prices">
                      <button
                        type="button"
                        class="btn btn--green"
                        @click="updatePopup = true">
                        <span>Update</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div class="modal-wrapper" v-if="copyPopup">
                <div class="modal-backdrop"></div>
                <div class="modal-inner">
                  <div class="edit-popup edit-popup--copy-md">
                    <div class="edit-popup__header">
                      <div class="edit-popup__title">
                        <div class="edit-popup__title__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-recover">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                          </svg>
                        </div>
                        <span>Copy from another year</span>
                      </div>
                      <div class="edit-popup__close" @click="copyPopup = false">
                        <svg width="1em" height="1em" class="icon icon-close">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                        </svg>
                      </div>
                    </div>
                    <form action="javascript:void(0)" class="edit-popup__inner">
                      <div class="edit-popup__form-2">
                        <div class="form-control-group">
                          <span class="form-control-label">Choose year</span>
                          <div
                            :class="[
                              'select-wrapper',
                              {'is-active': copyPopupOpen},
                            ]"
                            @click="copyPopupOpen = !copyPopupOpen">
                            <div class="select-trigger">
                              <span class="select-trigger__name">{{
                                copyPopupFrom
                              }}</span
                              ><span class="select-trigger__icon">
                                <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-chevron">
                                  <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                              ></span>
                            </div>
                            <div class="select-body">
                              <div class="select-inner js-scrollbar">
                                <div
                                  v-for="(y, index) in data.years.filter(
                                    (y) => !(y === copyPopup)
                                  )"
                                  :key="index"
                                  :class="[
                                    'select-option',
                                    {'is-selected': copyPopupFrom === y},
                                  ]"
                                  @click="copyPopupFrom = y">
                                  <span class="select-option__name">{{
                                    y
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button
                          type="submit"
                          class="btn btn--green edit-popup__submit-2"
                          @click="
                            copyYearOldHandler()
                            copyPopup = false
                          ">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-recover">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                          </svg>
                          <span>Copy</span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal-wrapper" v-if="updatePopup">
                <div class="modal-backdrop"></div>
                <div class="modal-inner">
                  <div class="edit-popup edit-popup--history">
                    <div class="edit-popup__header">
                      <div class="edit-popup__title">Update History</div>
                      <div
                        class="edit-popup__close"
                        @click="updatePopup = false">
                        <svg width="1em" height="1em" class="icon icon-close">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                        </svg>
                      </div>
                    </div>
                    <form action="javascript:void(0)" class="edit-popup__inner">
                      <div class="form-control-group">
                        <span class="form-control-label"
                          >Hi {{ user ? user.data.firstName : '' }},
                          <span> what have you updated?</span>
                        </span>
                        <div class="form-control-wrap">
                          <textarea
                            class="form-control"
                            v-model="descriptionUpdate">
Rates, Hotel Description</textarea
                          >
                        </div>
                        <div class="edit-popup__error-text">
                          <span v-if="descriptionUpdate.length < 6">Minimum 6 symbols are required</span>
                        </div>
                      </div>
                      <div class="options-additional__btns">
                        <button
                          type="button"
                          class="btn btn--silver"
                          @click="updatePopup = false">
                          <span>Cancel</span>
                        </button>
                        <button
                          type="submit"
                          class="btn btn--green edit-popup__submit"
                          :disabled="descriptionUpdate.length < 6"
                          @click="updateHotelsRoomPricesHandler">
                          <span>Update</span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal-wrapper" v-if="verifyPopup">
                <div class="modal-backdrop"></div>
                <div class="modal-inner">
                  <div class="edit-popup edit-popup--verify">
                    <div class="edit-popup__header">
                      <div class="edit-popup__title">
                        <div class="edit-popup__title__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-verify">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-verify"></use>
                          </svg>
                        </div>
                        <span>Verify Rates</span>
                      </div>
                      <div
                        class="edit-popup__close"
                        @click="verifyPopup = false">
                        <svg width="1em" height="1em" class="icon icon-close">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                        </svg>
                      </div>
                    </div>
                    <div class="text-verify">
                      Please confirm that you’ve checked the prices and want to
                      verify rates under your name
                    </div>
                    <div class="edit-popup__btns-2">
                      <button
                        type="button"
                        class="btn btn--silver btn__verify"
                        @click="verifyPopup = false">
                        <span>Cancel</span>
                      </button>
                      <button
                        type="button"
                        class="btn btn--green btn__verify"
                        @click="verifyPopup = false">
                        <span>Confirm and Verify</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-wrapper" v-if="leave" :style="{zIndex: 200}">
                <div class="modal-backdrop"></div>
                <div class="modal-inner">
                  <div class="edit-popup info-popup info-popup_actions">
                    <div class="edit-popup__header">
                      <div class="info-title">
                        <div class="info-title__icon">
                          <svg width="3rem" height="3rem">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#info-actions-icon"></use>
                          </svg>
                        </div>
                        <span class="info-title__heading"
                          >It looks like you have been editing something</span
                        >
                      </div>
                      <div
                        class="edit-popup__close"
                        @click="
                          leave = false
                          isEdit = false
                        ">
                        <svg width="1em" height="1em" class="icon icon-close">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                        </svg>
                      </div>
                    </div>
                    <div class="info-popup__text">
                      <p>
                        If you leave before saving, your changes will be lost.
                        Are you sure you want to leave?
                      </p>
                    </div>
                    <div class="info-popup__btns">
                      <button
                        type="button"
                        class="btn btn--silver"
                        @click="
                          leave = false
                          isEdit = false
                        ">
                        <span>Leave without saving</span>
                      </button>
                      <button
                        type="button"
                        class="btn btn--green btn--shadowed"
                        @click="
                          leave = false
                          isEdit = false
                        ">
                        <span>Stay</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-wrapper" v-if="showCopyPricesPopup">
                <div class="modal-backdrop"></div>
                <div class="modal-inner" style="align-items: flex-start">
                  <div class="edit-popup edit-popup--participants">
                    <div class="edit-popup__header">
                      <div class="edit-popup__title">
                        <span>Copy prices to chosen rooms</span>
                      </div>
                      <div
                        class="edit-popup__close"
                        @click="onHideCopyPricesPopup">
                        <svg width="1em" height="1em" class="icon icon-close">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                        </svg>
                      </div>
                    </div>
                    <div class="list-edit-participants">
                      <div
                        v-for="(item, index) in prices"
                        :key="index"
                        class="list-edit-participants__item list-edit-participants__item--no-border">
                        <div class="list-edit-participants__checkbox">
                          <label
                            :for="'chk_1110__free' + index"
                            class="form-control-checkbox">
                            <input
                              v-model="item.active"
                              :id="'chk_1110__free' + index"
                              type="checkbox" />
                            <span class="form-control-checkbox__box">
                              <svg
                                width="1em"
                                height="1em"
                                class="icon icon-check">
                                <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                              </svg>
                            </span>
                            <span class="form-control-checkbox__name">{{
                              item.roomName
                            }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="options-additional__btns">
                      <button
                        type="button"
                        class="btn btn--silver btn_options"
                        @click="onHideCopyPricesPopup">
                        <span>Cancel</span>
                      </button>
                      <button
                        type="button"
                        class="btn btn--green btn--shadowed btn_options"
                        @click="copyFromRoom"
                        :disabled="!isActiveRoomsExist">
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          :style="{zIndex: 1, marginRight: '8px'}">
                          <path
                            d="M8.8535 3.25174V0H4.30176V9.10001H12.1018V3.25174H8.8535Z"
                            fill="white" />
                          <path
                            d="M10.1533 0V1.95174H12.1051L10.1533 0Z"
                            fill="white" />
                          <path
                            d="M3.00137 10.3996V2.59961H0.401367V12.9996H9.50138V10.3996H3.00137Z"
                            fill="white" />
                        </svg>
                        <span>Copy</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="modal-wrapper" v-if="copyPopup">
                  <div class="modal-backdrop"></div>
                  <div class="modal-inner">
                    <div class="edit-popup edit-popup--copy-md">
                      <div class="edit-popup__header">
                        <div class="edit-popup__title">
                          <div class="edit-popup__title__icon">
                            <svg
                              width="1em"
                              height="1em"
                              class="icon icon-recover">
                              <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                            </svg>
                          </div>
                          <span>Copy from another year</span>
                        </div>
                        <div
                          class="edit-popup__close"
                          @click="copyPopup = false">
                          <svg width="1em" height="1em" class="icon icon-close">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </div>
                      </div>
                      <form
                        action="javascript:void(0)"
                        class="edit-popup__inner">
                        <div class="edit-popup__form-2">
                          <div class="form-control-group">
                            <span class="form-control-label">Choose year</span>
                            <div
                              :class="[
                                'select-wrapper',
                                {'is-active': copyPopupOpen},
                              ]"
                              @click="copyPopupOpen = !copyPopupOpen">
                              <div class="select-trigger">
                                <span class="select-trigger__name">{{
                                  copyPopupFrom
                                }}</span
                                ><span class="select-trigger__icon">
                                  <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-chevron">
                                    <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                ></span>
                              </div>
                              <div class="select-body">
                                <div class="select-inner js-scrollbar">
                                  <div
                                    v-for="(y, index) in data.years.filter(
                                      (y) => !(y === copyPopup)
                                    )"
                                    :key="index"
                                    :class="[
                                      'select-option',
                                      {'is-selected': copyPopupFrom === y},
                                    ]"
                                    @click="copyPopupFrom = y">
                                    <span class="select-option__name">{{
                                      y
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <button
                            type="submit"
                            class="btn btn--green edit-popup__submit-2"
                            @click="
                              copyYearOldHandler()
                              copyPopup = false
                            ">
                            <svg
                              width="1em"
                              height="1em"
                              class="icon icon-recover">
                              <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                            </svg>
                            <span>Copy</span>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="modal-wrapper" v-if="updatePopup">
                  <div class="modal-backdrop"></div>
                  <div class="modal-inner">
                    <div class="edit-popup edit-popup--history">
                      <div class="edit-popup__header">
                        <div class="edit-popup__title">Update History</div>
                        <div
                          class="edit-popup__close"
                          @click="updatePopup = false">
                          <svg width="1em" height="1em" class="icon icon-close">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </div>
                      </div>
                      <form
                        action="javascript:void(0)"
                        class="edit-popup__inner">
                        <div class="form-control-group">
                          <span class="form-control-label"
                            >Hi {{ user ? user.data.firstName : '' }},
                            <span> what have you updated?</span>
                          </span>
                          <div class="form-control-wrap">
                            <textarea
                              class="form-control"
                              v-model="descriptionUpdate">
Rates, Hotel Description</textarea
                            >
                          </div>
                        </div>
                        <div class="options-additional__btns">
                          <button
                            type="button"
                            class="btn btn--silver"
                            @click="updatePopup = false">
                            <span>Cancel</span>
                          </button>
                          <button
                            type="submit"
                            class="btn btn--green edit-popup__submit"
                            @click="updateHotelsRoomPricesHandler">
                            <span>Update</span>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="modal-wrapper" v-if="verifyPopup">
                  <div class="modal-backdrop"></div>
                  <div class="modal-inner">
                    <div class="edit-popup edit-popup--verify">
                      <div class="edit-popup__header">
                        <div class="edit-popup__title">
                          <div class="edit-popup__title__icon">
                            <svg
                              width="1em"
                              height="1em"
                              class="icon icon-verify">
                              <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-verify"></use>
                            </svg>
                          </div>
                          <span>Verify Rates</span>
                        </div>
                        <div
                          class="edit-popup__close"
                          @click="verifyPopup = false">
                          <svg width="1em" height="1em" class="icon icon-close">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </div>
                      </div>
                      <div class="text-verify">
                        Please confirm that you’ve checked the prices and want
                        to verify rates under your name
                      </div>
                      <div class="edit-popup__btns-2">
                        <button
                          type="button"
                          class="btn btn--silver btn__verify"
                          @click="verifyPopup = false">
                          <span>Cancel</span>
                        </button>
                        <button
                          type="button"
                          class="btn btn--green btn__verify"
                          @click="verifyPopup = false">
                          <span>Confirm and Verify</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {
  calculateHotelsRoomPrices,
  getHotelAdvanced,
  // getHotelsAdvanced,
  getHotelsRoomPrices,
  getHotelsRoomPricesResults,
  updateHotelPrice,
  updateHotelsRoomPrices,
  updateHotelsRoomPricesResults,
} from '@/utilites/api'
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'

export default {
  components: {HotelsSideMenu},
  data() {
    return {
      showCopyPricesPopup: false,
      copiedPricesIndex: 0,
      leave: false,
      updatePopup: false,
      descriptionUpdate: '',
      year: new Date().getFullYear(),
      copyHotel: null,
      copyYear: null,
      verifyPopup: false,
      prices: {},
      copyPopup: false,
      copyPopupFrom: '',
      copyPopupOpen: false,
      isEdit: false,
      resultSelect: false,
      showPrice: false,
      resultType: '',
      filterPrice: {
        title: 'All',
        type: 'ALL',
      },
      results: {},
      selects: {
        year: false,
        hotel: false,
        copyHotel: false,
        copyYear: false,
      },
      data: {
        years: [],
        hotels: [],
        filter: [],
      },
      hotelName: '',
      checkedResultType: false,
      pricesUpdating: false,
    }
  },
  props: ['user'],
  created() {
    getHotelAdvanced(this.$route.params.id).then((res) => {
      this.hotelName = res.names.EN
    })
  },
  mounted() {
    this.updateData()
    const tempYears = [];
    const lastYear = new Date().getFullYear() + 10;
    for (let i = 2021; i < lastYear; i++) {
      tempYears.push(i);
    }
    this.data.years = tempYears;
    window.addEventListener('click', (event) => {
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          year: false,
          hotel: false,
          copyHotel: false,
          copyYear: false,
        }
        this.resultSelect = false
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  methods: {
    onShowCopyPricesPopup(index) {
      this.showCopyPricesPopup = true
      this.copiedPricesIndex = index
    },
    onHideCopyPricesPopup() {
      this.showCopyPricesPopup = false
      this.prices.map((price) => (price.active = false))
    },
    copyFromRoom() {
      const copiedSeasons = this.prices[this.copiedPricesIndex].seasons
      const filteredPrice = this.prices.filter((price) => price.active)

      for (let price of filteredPrice) {
        price.seasons.forEach((season, index) => {
          Object.keys(season.prices).forEach((pKey) => {
            season.prices[pKey].price = copiedSeasons[index].prices[pKey].price
            season.prices[pKey].enabled =
              copiedSeasons[index].prices[pKey].enabled
            season.prices[pKey].type = copiedSeasons[index].prices[pKey].type
          })
        })
      }
      this.onHideCopyPricesPopup()
    },
    updateSpecificHotelPrice(room, season) {
      // this.isEdit = true
      this.pricesUpdating = true
      const updateData = {
        id: room.id,
        hotelId: +this.$route.params.id,
        year: this.year,
        seasonId: season.seasonId,
        roomId: room.roomId,
        roomType: 'SPECIFIC',
        mealType: this.resultType,
        accommodation: room.accommodation,
        price: season.price,
        priceWithFees: season.priceWithFees,
      }
      updateHotelPrice(updateData).then((res) => {
        // this.updateHotelsRoomPricesHandler()
        // this.calcResultsPrices()
        this.updateData()
      })
    },
    copyYearOldHandler() {
      const id = this.$route.params.id
      Promise.allSettled([getHotelsRoomPrices(id, this.copyPopupFrom)]).then(
        (res) => {
          if (res[0].status === 'fulfilled') {
            let prices = []
            let result = []
            let seasons = []
            result = res[0].value
            if (this.prices.length) {
              this.prices[0].seasons.forEach((item) => {
                seasons.push(item.seasonId)
              })
              result = result.filter((i) =>
                seasons.some((season) => season === i.seasonId)
              )
            }
            result.forEach((item) => {
              let rooms = result.filter((i) => i.roomId === item.roomId)
              if (rooms.length) {
                prices.push({
                  id: rooms[0].id,
                  hotelId: rooms[0].hotelId,
                  roomId: rooms[0].roomId,
                  roomName: rooms[0].roomName,
                  year: this.year,
                  types: rooms[0].prices,
                  seasons: rooms.map((r) => ({
                    id: null,
                    seasonId: r.seasonId,
                    seasonName: r.seasonName,
                    prices: r.prices,
                  })),
                })
              }
            })
            let resultPrices = []
            prices.forEach((item) => {
              if (!resultPrices.find((i) => i.roomId === item.roomId)) {
                resultPrices.push(item)
              }
            })

            if (this.prices.length) {
              resultPrices = resultPrices.map((item, index) => {
                return {
                  ...item,
                  id: this.prices[index].id,
                  seasons: item.seasons.map((s, idx) => ({
                    ...s,
                    id: this.prices[index].seasons[idx].id,
                  })),
                }
              })
            }

            this.prices = resultPrices.map((item) => ({
              ...item,
              collapse: false,
              active: false,
            }))
          }

          this.isEdit = false
          // this.data.hotels = res[1].value
          this.isLoad = true
        }
      )
    },
    onCheckIsEdit(name) {
      if (this.isEdit) {
        this.leave = true
      } else {
        this.selects = {
          year: false,
          hotel: false,
          copyHotel: false,
          copyYear: false,
          [name]: !this.selects[name],
        }
      }
    },
    updateData() {
      const id = this.$route.params.id
      this.updateDatePickers()
      Promise.allSettled([
        getHotelsRoomPrices(id, this.year),
        getHotelsRoomPricesResults(id, this.year),
      ]).then((res) => {
        if (res[0].status === 'fulfilled') {
          let prices = []
          let result = []
          result = res[0].value
          result.forEach((item) => {
            let rooms = result.filter((i) => i.roomId === item.roomId)
            if (rooms.length) {
              prices.push({
                id: rooms[0].id,
                hotelId: rooms[0].hotelId,
                roomId: rooms[0].roomId,
                roomName: rooms[0].roomName,
                year: rooms[0].year,
                types: rooms[0].prices,
                seasons: rooms.map((r) => ({
                  id: r.id,
                  seasonId: r.seasonId,
                  seasonName: r.seasonName,
                  prices: r.prices,
                })),
              })
            }
          })
          let resultPrices = []
          prices.forEach((item) => {
            if (!resultPrices.find((i) => i.roomId === item.roomId)) {
              resultPrices.push(item)
            }
          })
          this.prices = resultPrices.map((item) => ({
            ...item,
            collapse: false,
            active: false,
          }))
        }
        if (res[1].status === 'fulfilled') {
          this.results = res[1].value
          if (Object.keys(res[1].value.prices)[0] && !this.checkedResultType)
            this.resultType = Object.keys(res[1].value.prices)[0]
          if (this.results.prices && res[1].value.prices[this.resultType]) {
            let filteredData = []
            let uniqeData = []
            // res[1].value.prices[this.resultType].forEach(item => {
            //   filteredData = filteredData.concat(item.map(room => ({
            //     title: item.roomName + '(' + item.type + ')',
            //     type: item.type,
            //     id: item.roomId
            //   })))
            // })
            res[1].value.prices[this.resultType].forEach((item) => {
              filteredData.push({
                title: item.roomName + ' (' + item.type + ')',
                type: item.type,
                id: item.roomId,
              })
            })
            filteredData.forEach((elem) => {
              if (!uniqeData.map((i) => i.title).includes(elem.title)) {
                uniqeData.push(elem)
              }
            })
            this.data.filter = uniqeData
          }
        }

        this.isEdit = false
        // this.data.hotels = res[2].value
        this.isLoad = true
        this.pricesUpdating = false
      })
    },
    generataData() {
      let data = []
      this.prices.forEach((item) => {
        data = data.concat(
          item.seasons.map((season) => ({
            id: season.id,
            hotelId: item.hotelId,
            roomId: item.roomId,
            seasonId: season.seasonId,
            year: item.year,
            prices: {
              perPersonRate: {
                enabled: item.seasons[0].prices.perPersonRate.enabled,
                type: item.seasons[0].prices.perPersonRate.type,
                price: season.prices.perPersonRate.price,
              },
              singleSupplement: {
                enabled: item.seasons[0].prices.singleSupplement.enabled,
                type: item.seasons[0].prices.singleSupplement.type,
                price: season.prices.singleSupplement.price,
              },
              thirdAdult: {
                enabled: item.seasons[0].prices.thirdAdult.enabled,
                type: item.seasons[0].prices.thirdAdult.type,
                price: season.prices.thirdAdult.price,
              },
              teenagerAlone: {
                enabled: item.seasons[0].prices.teenagerAlone.enabled,
                type: item.seasons[0].prices.teenagerAlone.type,
                price: season.prices.teenagerAlone.price,
              },
              firstTeenager1Adult: {
                enabled: item.seasons[0].prices.firstTeenager1Adult.enabled,
                type: item.seasons[0].prices.firstTeenager1Adult.type,
                price: season.prices.firstTeenager1Adult.price,
              },
              firstTeenager2Adult: {
                enabled: item.seasons[0].prices.firstTeenager2Adult.enabled,
                type: item.seasons[0].prices.firstTeenager2Adult.type,
                price: season.prices.firstTeenager2Adult.price,
              },
              secondTeenager1Adult: {
                enabled: item.seasons[0].prices.secondTeenager1Adult.enabled,
                type: item.seasons[0].prices.secondTeenager1Adult.type,
                price: season.prices.secondTeenager1Adult.price,
              },
              secondTeenager2Adult: {
                enabled: item.seasons[0].prices.secondTeenager2Adult.enabled,
                type: item.seasons[0].prices.secondTeenager2Adult.type,
                price: season.prices.secondTeenager2Adult.price,
              },
              firstChild1Adult: {
                enabled: item.seasons[0].prices.firstChild1Adult.enabled,
                type: item.seasons[0].prices.firstChild1Adult.type,
                price: season.prices.firstChild1Adult.price,
              },
              firstChild2Adult: {
                enabled: item.seasons[0].prices.firstChild2Adult.enabled,
                type: item.seasons[0].prices.firstChild2Adult.type,
                price: season.prices.firstChild2Adult.price,
              },
              secondChild1Adult: {
                enabled: item.seasons[0].prices.secondChild1Adult.enabled,
                type: item.seasons[0].prices.secondChild1Adult.type,
                price: season.prices.secondChild1Adult.price,
              },
              secondChild2Adult: {
                enabled: item.seasons[0].prices.secondChild2Adult.enabled,
                type: item.seasons[0].prices.secondChild2Adult.type,
                price: season.prices.secondChild2Adult.price,
              },
            },
          }))
        )
        return item
      })
      return data
    },
    updateHotelsRoomPricesHandler() {
      let data = this.generataData()
      Promise.all([
        updateHotelsRoomPrices(
          {
            prices: data,
            history: {
              hotelId: this.$route.params.id,
              userId: this.user.id,
              description: this.descriptionUpdate,
            },
          },
          this.$route.params.id,
          this.year
        ),
        updateHotelsRoomPricesResults({results: this.results}),
      ]).then((res) => {
        this.$emit('confirmed')
        this.isEdit = false
        this.descriptionUpdate = ''
        this.updatePopup = false
      })
    },
    calcResultsPrices() {
      let data = this.generataData()
      calculateHotelsRoomPrices({
        prices: data,
        history: {
          hotelId: this.$route.params.id,
          userId: this.user.id,
          description: this.descriptionUpdate,
        },
      }).then((res) => {
        this.$emit('confirmed')
        this.results = res
        let filteredData = []
        let uniqeData = []
        if (Object.keys(res.prices)[0])
          this.resultType = Object.keys(res.prices)[0]
        res.prices[this.resultType].forEach((item) => {
          // filteredData = filteredData.concat(item.roomPrices.map(room => ({
          //   title: room.roomName + '(' + item.type + ')',
          //   type: item.type,
          //   id: room.roomId
          // })))
          filteredData.push({
            title: item.roomName + ' (' + item.type + ')',
            type: item.type,
            id: item.roomId,
          })
        })
        filteredData.forEach((elem) => {
          if (!uniqeData.map((i) => i.title).includes(elem.title)) {
            uniqeData.push(elem)
          }
        })
        this.data.filter = uniqeData
      })
    },
    updateDatePickers() {
      document.querySelectorAll('.lightpick').forEach((elem) => {
        elem.remove()
      })
      setTimeout(() => {
        document.querySelectorAll('.js-datepicker-single').forEach((item) => {
          const datePicker = new Lightpick({
            field: item,
            singleDate: true,
            lang: 'en',
            format: 'DD MMM YYYY',
            onClose: function () {
              item.blur()
            },
            onSelect: function () {
              item.focus()
              item.blur()
            },
          })
          item.addEventListener('blur', () => {
            datePicker.hide()
          })
        })
      }, 1000)
    },
    waitSaveTiming() {
      const saveFun = () => {
        this.updatePopup = true
      }
      const waitFun = () => {
        this.waitSaveTiming()
      }
      setTimeout(() => {
        this.$emit('waitSaveHandler', [saveFun, waitFun])
      }, 10 * 60 * 1000)
    },
  },
  watch: {
    isEdit(val) {
      if (val) this.waitSaveTiming()
    },
    year() {
      this.updateData()
    },
    resultType() {
      if (this.results) {
        let filteredData = []
        let uniqeData = []
        this.results.prices[this.resultType].forEach((item) => {
          // filteredData = filteredData.concat(item.roomPrices.map(room => ({
          //   title: room.roomName + '(' + item.type + ')',
          //   type: item.type,
          //   id: room.roomId
          // })))
          filteredData.push({
            title: item.roomName + ' (' + item.type + ')',
            type: item.type,
            id: item.roomId,
          })
        })
        filteredData.forEach((elem) => {
          if (!uniqeData.map((i) => i.title).includes(elem.title)) {
            uniqeData.push(elem)
          }
        })
        this.data.filter = uniqeData
      }
    },
  },
  computed: {
    isActiveRoomsExist() {
      return !!this.prices.filter((price) => price.active).length
    },
    filteredResults() {
      if (this.results.prices && this.results.prices[this.resultType]) {
        let types = []
        let results = []
        let finishResults = []
        this.results.prices[this.resultType].forEach((item) => {
          if (!types.map((type) => type.type).includes(item.type)) {
            types.push({type: item.type})
          }
          item.roomPrices.forEach((data) => {
            data.roomId = item.roomId
            data.roomName = item.roomName
            data.seasonId = item.seasonId
            data.seasonName = item.seasonName
          })
        })
        types.forEach((item) => {
          results.push({
            type: item.type,
            rooms: this.results.prices[this.resultType]
              .filter((room) => room.type === item.type)
              .map((room) => room.roomPrices)
              .flat(),
          })
        })
        results.forEach((item) => {
          let rooms = []
          let finishRooms = []
          item.rooms.forEach((room) => {
            let roomsForId = item.rooms.filter(
              (r) =>
                r.roomId === room.roomId &&
                r.accommodation === room.accommodation
            )
            if (roomsForId.length) {
              rooms.push({
                id: roomsForId[0].id,
                roomId: roomsForId[0].roomId,
                roomName: roomsForId[0].roomName,
                accommodation: roomsForId[0].accommodation,
                accommodationData: roomsForId[0].accommodation
                  .match(/.{1,2}/g)
                  .map((str) => {
                    return {
                      count: +str[0],
                      type: str[1],
                    }
                  }),
                seasons: roomsForId.map((r) => ({
                  seasonId: r.seasonId,
                  seasonName: r.seasonName,
                  price: r.price,
                  priceWithFees: r.priceWithFees,
                })),
              })
            }
          })
          rooms.forEach((elem) => {
            if (
              !finishRooms.find(
                (item) =>
                  item.roomId === elem.roomId &&
                  item.accommodation === elem.accommodation
              )
            ) {
              finishRooms.push(elem)
            }
          })
          finishResults.push({
            type: item.type,
            rooms: finishRooms,
          })
        })
        if (this.filterPrice.type === 'ALL') {
          return finishResults
        } else {
          return finishResults
            .filter((item) => {
              if (item.type === this.filterPrice.type) {
                return true
              }
              return false
            })
            .map((item) => {
              return {
                ...item,
                rooms: item.rooms.filter(
                  (room) => room.roomId === this.filterPrice.id
                ),
              }
            })
            .filter((item) => item.rooms.length > 0)
        }
      }
      return []
    },
  },
}
</script>
